import { Routes, Route, Navigate } from "react-router-dom";
import AffiliateDashboard from "../pages/AffiliatedPartnerPortal/AffiliatedPartner";
import MainLayout from "./MainLayout";
import AffiliatePartnerForm from "../pages/AffiliatedPartnerPortal/AffiliatePartnerForm";
import AffiliateLeads from "../pages/AffiliatedPartnerPortal/AffiliateLeads";
import AffiliatePartnerDashboard from "../pages/AffiliatedPartnerPortal/AffiliatePartnerDashboard";
import AffiliatedProfile from "../pages/AffiliatedPartnerPortal/AffiliatedProfile";

const AffiliatePartnerLayout = () => {
  return (
    <MainLayout>
      <Routes>
        <Route index element={<Navigate to="dashboard" />} />
        <Route path="dashboard" element={<AffiliatePartnerDashboard />} />
        <Route path="new" element={<AffiliatePartnerForm />} />
        <Route path="leads" element={<AffiliateLeads />} />
        <Route path="profile" element={<AffiliatedProfile />} />
        <Route
          path="*"
          element={
            <div className="flex items-center justify-center min-h-screen bg-[#131313] text-white p-4">
              <div className="text-center">
                <h1 className="text-5xl font-bold text-[#FFCA20] mb-4">404</h1>
                <h2 className="text-2xl mb-4">Page Not Found</h2>
                <p className="text-gray-400 mb-6">
                  The page you are looking for doesn't exist or you are not
                  authorised.
                </p>
                <a
                  href="/affiliate-partner/dashboard"
                  className="bg-[#FFCA20] hover:bg-yellow-600 text-black font-medium py-2 px-6 rounded"
                >
                  Go to Dashboard
                </a>
              </div>
            </div>
          }
        />
      </Routes>
    </MainLayout>
  );
};

export default AffiliatePartnerLayout;
